class ContentImageGallery extends HTMLElement {
  constructor() {
    super();

    if (this.getAttribute('aria-controls')) {
      const controls = this.getAttribute('aria-controls')
        .split(' ')
        .map((id) => document.getElementById(id));

      controls.forEach((control) =>
        control.addEventListener('swatch:change', (e) => this.fetchImageGallery(e.detail.swatch)),
      );
    }

    this.gallery = this.querySelector('.swiper-gallery') || false;
    this.wrapper = this.querySelector('.swiper-wrapper') || false;
    this.toggle = this.querySelector('.swiper-toggle-fullscreen') || false;

    this.init();
  }

  init() {
    if (this.gallery && this.wrapper && this.toggle) {
      this.wrapper.addEventListener('click', this.openGallery.bind(this));
      this.toggle.addEventListener('click', this.closeGallery.bind(this));
    }
  }

  openGallery() {
    if (!this.gallery.classList.contains('swiper-gallery-fullscreen') && window.innerWidth < 1024) {
      this.gallery.classList.add('swiper-gallery-fullscreen');
    }
  }

  closeGallery() {
    if (this.gallery.classList.contains('swiper-gallery-fullscreen') && window.innerWidth < 1024) {
      this.gallery.classList.remove('swiper-gallery-fullscreen');
    }
  }

  async fetchImageGallery(swatch) {
    try {
      const response = await fetch(`${swatch.href}?section_id=content-image-gallery`);
      const result = await response.text();
      this.renderContents(result);
    } catch (e) {
      console.error(`Failed to fetch image gallery: ${e.message}`);
    }
  }

  renderContents(parsedState) {
    document.getElementById('content-image-gallery').innerHTML = this.getSectionInnerHTML(parsedState, `#${this.id}`);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

customElements.define('content-image-gallery', ContentImageGallery);
